import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    testimonials: [],
    page: 1,
    page_size: 10,
    order_column: 'created_at',
    order_type: 'desc',
    dialog: false,
    testimonial: {
      id: null,
      full_name: '',
      user_type_id: null,
      content: null,
      rating: 0,
      image_url: null,
      position: 1,
      link: null,
      link_youtube: null
    },
    user_types: []
  },

  mutations: {
    setTestimonials(state, payload) {
      state.testimonials = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setSelectedTestimonial(state, payload) {
      state.testimonial = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setUserTypes(state, payload) {
      state.user_types = payload
    }
  },

  actions: {
    read({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/testimonial', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type
          }
        })
        .then(r => {
          commit('setTestimonials', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    update({ commit, dispatch, state }, id) {
      axios.admin
        .put('cms/testimonial/' + id, {
          full_name: state.testimonial.full_name,
          user_type_id: state.testimonial.user_type_id,
          content: state.testimonial.content,
          rating: state.testimonial.rating,
          image_url: state.testimonial.image_url,
          position: state.testimonial.position,
          link: state.testimonial.link,
          link_youtube: state.testimonial.link_youtube
        })
        .then(() => {
          commit('setDialog', false)
          commit('setSelectedTestimonial', {})
          dispatch('read')
        })
    },
    delete({ dispatch }, id) {
      axios.admin.put('cms/testimonial/delete/' + id).then(() => {
        dispatch('read')
      })
    },
    insert({ commit, dispatch, state }) {
      axios.admin
        .post('cms/testimonial', {
          full_name: state.testimonial.full_name,
          user_type_id: state.testimonial.user_type_id,
          content: state.testimonial.content,
          rating: state.testimonial.rating,
          image_url: state.testimonial.image_url,
          position: state.testimonial.position,
          link: state.testimonial.link,
          link_youtube: state.testimonial.link_youtube          
        })
        .then(() => {
          commit('setDialog', false)
          commit('setSelectedTestimonial', {})
          dispatch('read')
        })
    },
    getUserTypes({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/user-type')
        .then(r => {
          commit('setUserTypes', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  },

  getters: {}
}
